import { AuditLogExportComponent } from './audit-log-export/audit-log-export.component'
import { AuditLogsComponent } from './audit-logs.component'

import { MainLayoutComponent } from '../../components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const auditLogsRoutes: Routes = [
  {
    path: 'audit-logs',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'AUDIT_LOG_LIST',
        redirectTo: '/',
      },
    },
    children: [
      { path: '', component: AuditLogsComponent },
      { path: 'export', component: AuditLogExportComponent },
    ],
  },
]
